module.exports = __webpack_public_path__ + "static/media/sf-test-18.1bf71c59.mp3";